import { useState } from 'react';
import { DATA_BASE_URL } from '@lib/constants';

const certificates = [
  {
    id: 1,
    title: 'National Honor Society 2025',
    image: `${DATA_BASE_URL}/data/awards/photos/national_honor_society_2025.webp`,
    category: 'Honor Society'
  },
  {
    id: 2,
    title: 'Spanish Honors Society 2025',
    image: `${DATA_BASE_URL}/data/awards/photos/spanish_honors_society_2025.webp`,
    category: 'Honor Society'
  },
  {
    id: 3,
    title: 'IASAS Scholar Award 2025',
    image: `${DATA_BASE_URL}/data/awards/photos/iasas_scholar_award_2025.webp`,
    category: 'Scholar Award'
  },
  {
    id: 4,
    title: 'Mathematics Honors Society 2025',
    image: `${DATA_BASE_URL}/data/awards/photos/mathematics_honors_society_2025.webp`,
    category: 'Honor Society'
  },
  {
    id: 5,
    title: 'Mathematics Department Award 2023',
    image: `${DATA_BASE_URL}/data/awards/photos/mathematics_department_award_2023.webp`,
    category: 'Departmental Award'
  },
  {
    id: 6,
    title: 'Mathematics Department Award (Alternate)',
    image: `${DATA_BASE_URL}/data/awards/photos/mathematics_department_award_2023_alt.webp`,
    category: 'Departmental Award'
  },
  {
    id: 7,
    title: 'National Master Title 2023',
    image: `${DATA_BASE_URL}/data/awards/photos/national_master_title_2023.webp`,
    category: 'National Recognition'
  },
  {
    id: 8,
    title: 'NCFP Award Plaque',
    image: `${DATA_BASE_URL}/data/awards/photos/plaque_award_ncfp.webp`,
    category: 'Plaque'
  },
  {
    id: 9,
    title: 'Chess Recognition Plaque 2024',
    image: `${DATA_BASE_URL}/data/awards/photos/plaque_recognition_chess_php_2024.webp`,
    category: 'Plaque'
  }
];

const CertificatesGallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-theme-2)' }}>
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2
            className="text-4xl sm:text-5xl font-heading font-bold mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Certificates & Awards Gallery
          </h2>
          <p
            className="text-lg sm:text-xl max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            A visual collection of academic honors, certificates, and recognition plaques
          </p>
        </div>

        {/* Gallery Grid - Horizontal scroll on mobile, grid on desktop */}
        <div className="md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-4 lg:gap-6 overflow-x-auto md:overflow-x-visible">
          <div className="flex md:contents gap-4 pb-4 md:pb-0">
          {certificates.map((cert) => (
            <div
              key={cert.id}
              className="group relative aspect-square rounded-xl overflow-hidden shadow-card cursor-pointer transition-all duration-300 hover:shadow-card-hover flex-shrink-0 w-[280px] md:w-auto"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
              onClick={() => setSelectedImage(cert)}
            >
              {/* Certificate Image */}
              <img
                src={cert.image}
                alt={cert.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                loading="lazy"
              />

              {/* Overlay on Hover */}
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4"
                style={{
                  background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)'
                }}
              >
                <p className="text-white font-bold text-sm mb-1 line-clamp-2">
                  {cert.title}
                </p>
                <p className="text-xs" style={{ color: 'var(--color-accent-3)' }}>
                  {cert.category}
                </p>
              </div>

              {/* Category Badge */}
              <div
                className="absolute top-2 right-2 px-2 py-1 rounded-md text-xs font-semibold opacity-90"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  color: 'var(--color-accent-6)',
                  borderColor: 'var(--color-accent-5)',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                {cert.category}
              </div>
            </div>
          ))}
          </div>
        </div>

        {/* Full-screen Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full text-white text-2xl font-bold hover:bg-white hover:bg-opacity-20 transition-colors"
              onClick={() => setSelectedImage(null)}
              aria-label="Close modal"
            >
              ×
            </button>
            <div className="max-w-5xl max-h-full overflow-auto">
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="max-w-full max-h-[90vh] object-contain rounded-lg"
              />
              <div className="text-center mt-4 space-y-2">
                <h3 className="text-white text-xl font-bold">{selectedImage.title}</h3>
                <p style={{ color: 'var(--color-accent-3)' }} className="text-sm">
                  {selectedImage.category}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CertificatesGallerySection;
